import { Component, Inject } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-modal-anadir-todas",
  template: `
    <h2 mat-dialog-title>{{ data.titulo }}</h2>
    <mat-dialog-content>
      <form [formGroup]="data.form">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>
            {{ data.translation.CantidadLimite || "Cantidad límite" }}
            <span style="color: red">*</span>
          </mat-label>
          <input
            matInput
            formControlName="CantidadLimite"
            type="number"
            [min]="0"
            [max]="99999"
            step="1"
            (keydown)="onKeyDown($event)"
            (input)="onInput($event)"
            placeholder="0"
          />
          <mat-error *ngIf="data.form.get('CantidadLimite')?.hasError('required')">
            {{ data.translation.CampoRequerido || "Campo requerido" }}
          </mat-error>
          <mat-error *ngIf="data.form.get('CantidadLimite')?.hasError('pattern')">
            {{ data.translation.SoloNumeros || "Solo números" }}
          </mat-error>
          <mat-error *ngIf="data.form.get('CantidadLimite')?.hasError('min')">
            {{ data.translation.ValorMinimoCero || "El valor mínimo es 0" }}
          </mat-error>
          <mat-error *ngIf="data.form.get('CantidadLimite')?.hasError('maxlength')">
            {{ data.translation.MaximoCincoCaracteres || "Máximo 5 caracteres" }}
          </mat-error>
        </mat-form-field>

        <div style="margin-top: 10px">
          <mat-label>
            {{ data.translation.DeBaja || "De baja" }}
            <span style="color: red">*</span>
          </mat-label>
          <mat-slide-toggle formControlName="DeBaja"></mat-slide-toggle>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancelClick()">
        <mat-icon>close</mat-icon>
      </button>
      <button
        mat-button
        [disabled]="!data.form.valid"
        (click)="onConfirmClick()"
        color="primary"
      >
        {{ data.translation.Listo || "Listo" }}
      </button>
    </mat-dialog-actions>
  `,
})
export class ModalAnadirTodasComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalAnadirTodasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      titulo: string;
      form: FormGroup;
      translation: any;
    }
  ) {}

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onKeyDown(event: KeyboardEvent): void {
    // Prevenir entrada de caracteres negativos e permitir apenas números e teclas de controle
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    const isNumber = /^[0-9]$/.test(event.key);
    const isControlKey = allowedKeys.includes(event.key) || 
                         (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase()));
    
    if (!isNumber && !isControlKey) {
      event.preventDefault();
    }
    
    // Prevenir entrada de sinal negativo
    if (event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remover qualquer sinal negativo ou caracteres não numéricos
    value = value.replace(/[^0-9]/g, '');
    
    // Garantir que não seja negativo
    if (value === '' || parseInt(value, 10) < 0) {
      value = '0';
    }
    
    // Limitar a 5 caracteres (máximo 99999)
    const numValue = parseInt(value, 10);
    if (numValue > 99999) {
      value = '99999';
    } else if (value.length > 5) {
      value = value.substring(0, 5);
    }
    
    // Atualizar o valor do formulário
    const finalValue = value === '' ? '' : parseInt(value, 10);
    this.data.form.patchValue({
      CantidadLimite: finalValue
    }, { emitEvent: false });
    
    // Atualizar o valor do input também para garantir sincronização
    if (input.value !== value) {
      input.value = value;
    }
  }

  onConfirmClick(): void {
    if (this.data.form.valid) {
      const cantidadLimite = this.data.form.get("CantidadLimite")?.value;
      // Garantir que o valor seja não negativo
      const valorFinal = cantidadLimite < 0 ? 0 : cantidadLimite;
      
      this.dialogRef.close({
        confirmado: true,
        cantidadLimite: valorFinal.toString(),
        deBaja: this.data.form.get("DeBaja")?.value,
      });
    }
  }
}
